import { connect } from 'react-redux';
import SupplierAuthActions from './SupplierAuthActions';
import {
  setDialogDetails,
  setForceCloseEditDrawer,
  toggleSupplierAuthActivation,
} from '../../../store/supplierAuthorizationSlice';

const mapDispatch = {
  setDialogDetails,
  setForceCloseEditDrawer,
  toggleSupplierAuthActivation,
};

export default connect(null, mapDispatch)(SupplierAuthActions);
